<app-page-panel class="flex-fit" [showBackButton]="false" iconNameFontAwesome="done_all" pageTitle="Freigabe"
    [showBackColor]="true" [showDetailsButton]="false" [showSidepanelButton]="false" [showCloseButton]="true"
    [showContent]="false" (closeButtonClicked)="CloseButtonClick()">
</app-page-panel>
<form class="form" #projektForm="ngForm">
    <mat-dialog-content class="flex-force form-content">
        <div class="form-group flex flex-col flex-fill-force">
            <div class="flex flex-row flex-fit flex-gap-12">
                <mat-form-field class="flex-fill form-field-readonly">
                    <mat-label>Aktuelle Bearbeitung</mat-label>
                    <input matInput readonly placeholder="" [value]="dataFreigabe()?.bearbeiterAktuell"
                        name="bearbeitungAktuell" cdkFocusInitial>
                </mat-form-field>
                <mat-form-field class="flex-fill form-field-readonly">
                    <mat-label>Nächste Bearbeitung</mat-label>
                    <input matInput readonly placeholder="" [value]="dataFreigabe()?.bearbeiterNaechster"
                        name="bearbeitungNaechster">
                </mat-form-field>
            </div>
            <mat-form-field>
                <mat-label>Anmerkung / Begründung</mat-label>
                <textarea class="anmerkung" matInput rows="5"
                    placeholder="" [(ngModel)]="dataFreigabeAnmerkung"
                    name="anmerkung"></textarea>
            </mat-form-field>
            <div class="flex flex-row flex-fit flex-gap-48 file-uploader-box">
                <dx-file-uploader #fileUploader 
                    class="flex-fill"
                    [multiple]="false"
                    [showFileList]="true"
                    [allowedFileExtensions]="['.pdf']"
                    readyToUploadMessage=""
                    allowedFileExtensionsMessage="Nur PDF-Dateien sind erlaubt!"
                    accept="application/pdf"
                    uploadMode="useForm"
                    (onValueChanged)="onFileUploadValueChanged($event)">
                </dx-file-uploader>
                <div class="flex flex-row flex-fit">
                    <button [disabled]="!dataFile().size" type="button" mat-icon-button (click)="onFileUploadDeleteButtonClick()" title="Datei löschen">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button [disabled]="!dataFile().size" type="button" mat-icon-button (click)="onFileUploadShowButtonClick()" title="Datei anzeigen">
                        <mat-icon>open_in_new</mat-icon>
                    </button>                            
                </div>
            </div>
            <div class="flex flex-row flex-stretch-self textarea-fit" style="overflow: scroll;">
                <div [innerHTML]="dataFreigabePlausibilitaet()">
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="flex-justify">
        <button (click)="button_showBericht_clicked()" mat-button>Abschlussbericht</button>
        <div>
            <button (click)="button_reject_clicked()"
                [disabled]="!projektForm.form.valid || IsErsterBearbeiter() || !dataFreigabeAnmerkung()"
                mat-button>Ablehnung</button>
            <button (click)="button_apply_clicked()"
                [disabled]="!projektForm.form.valid || !dataFreigabe()?.isPlausibel" mat-button>Genehmigung</button>
            <button mat-button mat-dialog-close>Schließen</button>
        </div>
    </mat-dialog-actions>
</form>